import { render } from "./NotificationDropdown.vue?vue&type=template&id=36ce24bb&scoped=true"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"

import "./NotificationDropdown.vue?vue&type=style&index=0&id=36ce24bb&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ce24bb"]])

export default __exports__